// Климатические параметры
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import {
  CFormLabel,
  CFormInput,
  CFormTextarea,
  CForm,
  CContainer,
  CRow,
  CCol,
  CFormCheck,
  CButton,
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell
} from '@coreui/react';
import PropTypes from 'prop-types';

const ClimateParametersTab = forwardRef(({ initialData, onSave }, ref) => {
  const [climateParameters, setClimateParameters] = useState([
    {
      id: 1,
      number: 1,
      characteristic: 'Снеговой район',
      indicator: '',
      normativeDocument: ''
    },
    {
      id: 2,
      number: 2,
      characteristic: 'Ветровой район',
      indicator: '',
      normativeDocument: ''
    },
    {
      id: 3,
      number: 3,
      characteristic: 'Тип местности',
      indicator: '',
      normativeDocument: ''
    },
    {
      id: 4,
      number: 4,
      characteristic: 'Гололедный район',
      indicator: '',
      normativeDocument: ''
    },
    {
      id: 5,
      number: 5,
      characteristic: 'Сейсмический район',
      indicator: '',
      normativeDocument: ''
    },
    {
      id: 6,
      number: 6,
      characteristic: 'Отрицательная расчетная температура наиболее холодных суток при обеспеченности 0.98',
      indicator: '',
      normativeDocument: ''
    },
    {
      id: 7,
      number: 7,
      characteristic: 'Среднегодовая температура воздуха',
      indicator: '',
      normativeDocument: ''
    },
    {
      id: 8,
      number: 8,
      characteristic: 'Климатический район',
      indicator: '',
      normativeDocument: ''
    }
  ]);

  const [selectedParameterId, setSelectedParameterId] = useState(null);

  useEffect(() => {
    if (initialData && initialData.climateParameters) {
      setClimateParameters(initialData.climateParameters);
    }
  }, [initialData]);

  const handleParameterClick = (id) => {
    setSelectedParameterId(id);
  };

  const handleClimateParametersClick = () => {
    console.log('Климатические параметры clicked');
  };

  const handleLoadDataClick = () => {
    console.log('Загрузить данные clicked');
  };

  const handleIndicatorChange = (id, value) => {
    setClimateParameters(climateParameters.map(item => 
      item.id === id ? { ...item, indicator: value } : item
    ));
  };

  const handleNormativeDocumentChange = (id, value) => {
    setClimateParameters(climateParameters.map(item => 
      item.id === id ? { ...item, normativeDocument: value } : item
    ));
  };

  const getFormDataForSave = () => {
    return {
      climateParameters
    };
  };

  useImperativeHandle(ref, () => ({
    save: async () => {
      if (onSave) {
        const formData = getFormDataForSave();
        await onSave(formData);
      }
    },
    getFormData: getFormDataForSave
  }));

  return (
    <CContainer fluid className="climate-parameters-tab-container">
      <CForm>
        {/* Кнопки управления */}
        <CRow className="mb-3">
          <CCol>
            <div className="d-flex gap-2">
              <CButton 
                color="light" 
                variant="outline" 
                size="sm" 
                className="text-dark border"
                onClick={handleClimateParametersClick}
              >
                Климатические параметры
              </CButton>
              <CButton 
                color="light" 
                variant="outline" 
                size="sm" 
                className="text-dark border"
                onClick={handleLoadDataClick}
              >
                Загрузить данные
              </CButton>
            </div>
          </CCol>
        </CRow>

        {/* Таблица климатических параметров */}
        <CRow className="mb-3">
          <CCol>
            <CTable bordered small className="mb-0">
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell className="border text-center" style={{ width: '50px' }}>№</CTableHeaderCell>
                  <CTableHeaderCell className="border text-center" style={{ width: '300px' }}>Наименование характеристики</CTableHeaderCell>
                  <CTableHeaderCell className="border text-center" style={{ width: '200px' }}>Показатель</CTableHeaderCell>
                  <CTableHeaderCell className="border text-center">Ссылка на нормативный документ</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {climateParameters.map((item) => (
                  <CTableRow 
                    key={item.id} 
                    onClick={() => handleParameterClick(item.id)}
                    className={selectedParameterId === item.id ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                  >
                    <CTableDataCell className="border text-center" style={{ width: '50px', verticalAlign: 'middle' }}>
                      {item.number}
                    </CTableDataCell>
                    <CTableDataCell className="border" style={{ width: '300px', verticalAlign: 'middle' }}>
                      {item.characteristic}
                    </CTableDataCell>
                    <CTableDataCell className="border p-0" style={{ width: '200px' }}>
                      <CFormInput
                        type="text"
                        value={item.indicator}
                        onChange={(e) => handleIndicatorChange(item.id, e.target.value)}
                        placeholder="Введите показатель"
                        className="border-0 w-100"
                        style={{ borderRadius: '0' }}
                      />
                    </CTableDataCell>
                    <CTableDataCell className="border p-0">
                      <CFormInput
                        type="text"
                        value={item.normativeDocument}
                        onChange={(e) => handleNormativeDocumentChange(item.id, e.target.value)}
                        placeholder="Введите ссылку на нормативный документ"
                        className="border-0 w-100"
                        style={{ borderRadius: '0' }}
                      />
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </CCol>
        </CRow>
      </CForm>
    </CContainer>
  );
});

ClimateParametersTab.propTypes = {
  initialData: PropTypes.shape({
    climateParameters: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        number: PropTypes.number.isRequired,
        characteristic: PropTypes.string.isRequired,
        indicator: PropTypes.string,
        normativeDocument: PropTypes.string
      })
    )
  }),
  onSave: PropTypes.func
};

ClimateParametersTab.defaultProps = {
  initialData: null,
  onSave: null
};

export default ClimateParametersTab;